import { Action } from '@ngrx/store';
import {
  IUserAuth,
  ILogin,
  IGoogleLogin,
  IExternalData,
  IFormConfiguration,
} from '../../../commons';

export enum AuthenticationActionTypes {
  LoginNavigate = '[Authentication] Navigation Success',
  Login = '[Authentication] Login',
  GoogleLogin = '[Authentication] Google Login',
  RegisterGoogle = '[Authentication] Register Google',
  Logout = '[Authentication] Logout',
  PostLogout = '[Authentication] PostLogout',
  GoogleLoginSuccess = '[Authentication] Google Login Success',
  GoogleLoginFailure = '[Authentication] Google Login Failure',
  LoginSuccess = '[Authentication] Login Success',
  LoginFailure = '[Authentication] Login Failure',
  LoginRedirect = '[Authentication] Login Redirect',
  LoadAuthenticationState = '[Authentication] Load Authentication State',
  LoadAuthenticationStateSuccess = '[Authentication] Load Authentication State Success',
  LoadExternalProfileState = '[Authentication] Load External Profile State',
  LoadExternalProfileStateSuccess = '[Authentication] Load External Profile State Success',
  LoadFormConfigState = '[Home] Load Forms and EIN Config State',
  LoadFormConfigStateSuccess = '[Home] Load Forms and EIN Config State Success',
  LoadFormOrProfileStateFail = '[Authentication] Load Form or Profile State Fail',
  AuthenticationRedirect = '[Authentication] Checked Stored Authentication Success',
  LoadAuthenticationStateFail = '[Authentication] Load Authentication State Fail',
  LoginErrorReset = '[Authentication] Login Error Reset',
}

export class LoadAuthenticationState implements Action {
  readonly type = AuthenticationActionTypes.LoadAuthenticationState;
}

export class LoadAuthenticationStateSuccess implements Action {
  readonly type = AuthenticationActionTypes.LoadAuthenticationStateSuccess;
  constructor(public payload: IUserAuth) {}
}

export class LoadExternalProfileState implements Action {
  readonly type = AuthenticationActionTypes.LoadExternalProfileState;
  // constructor(public payload: IUserAuth) {}
}

export class LoadExternalProfileStateSuccess implements Action {
  readonly type = AuthenticationActionTypes.LoadExternalProfileStateSuccess;
  constructor(public payload: IExternalData) {}
}

export class LoadFormConfigState implements Action {
  readonly type = AuthenticationActionTypes.LoadFormConfigState;
  // constructor(public payload: IUserAuth) {}
}

export class LoadFormConfigStateSuccess implements Action {
  readonly type = AuthenticationActionTypes.LoadFormConfigStateSuccess;
  constructor(public payload: IFormConfiguration[]) {}
}

export class LoadFormOrProfileStateFail implements Action {
  readonly type = AuthenticationActionTypes.LoadFormOrProfileStateFail;
  constructor(public payload: any) {}
}

export class LoadAuthenticationStateFail implements Action {
  readonly type = AuthenticationActionTypes.LoadAuthenticationStateFail;
  constructor(public payload: any) {}
}

export class Login implements Action {
  readonly type = AuthenticationActionTypes.Login;
  constructor(public extLogin: ILogin) {}
}

export class GoogleLogin implements Action {
  readonly type = AuthenticationActionTypes.GoogleLogin;
  constructor(public payload: IGoogleLogin) {}
}

export class RegisterGoogle implements Action {
  readonly type = AuthenticationActionTypes.RegisterGoogle;
}

export class GoogleLoginSuccess implements Action {
  readonly type = AuthenticationActionTypes.GoogleLoginSuccess;
  constructor(public payload: IUserAuth) {}
}

export class GoogleLoginFailure implements Action {
  readonly type = AuthenticationActionTypes.GoogleLoginFailure;
  constructor(public payload: any) {}
}

export class LoginSuccess implements Action {
  readonly type = AuthenticationActionTypes.LoginSuccess;
  constructor(public payload: IUserAuth) {}
}

export class LoginNavigate implements Action {
  readonly type = AuthenticationActionTypes.LoginNavigate;
}

export class LoginFailure implements Action {
  readonly type = AuthenticationActionTypes.LoginFailure;
  constructor(public payload: any) {}
}

export class LoginErrorReset implements Action {
  readonly type = AuthenticationActionTypes.LoginErrorReset;
}

export class AuthenticationRedirect implements Action {
  readonly type = AuthenticationActionTypes.AuthenticationRedirect;
}

export class LoginRedirect implements Action {
  readonly type = AuthenticationActionTypes.LoginRedirect;
}

export class Logout implements Action {
  readonly type = AuthenticationActionTypes.Logout;
}

export class PostLogout implements Action {
  readonly type = AuthenticationActionTypes.PostLogout;
  // constructor(public payload: IUserAuth) {}
}

export type AuthenticationActions =
  | LoadAuthenticationState
  | LoadAuthenticationStateSuccess
  | LoadAuthenticationStateFail
  | LoadExternalProfileState
  | LoadExternalProfileStateSuccess
  | LoadFormConfigState
  | LoadFormConfigStateSuccess
  | LoadFormOrProfileStateFail
  | AuthenticationRedirect
  | Login
  | GoogleLogin
  | RegisterGoogle
  | GoogleLoginSuccess
  | GoogleLoginFailure
  | LoginSuccess
  | LoginFailure
  | LoginErrorReset
  | LoginRedirect
  | LoginNavigate
  | Logout
  | PostLogout;
